export enum ShortcutAction {
  NewSalesInvoice = 1,
  NewPurchaseInvoice = 2,
  NewReceiptVoucher = 3,
  NewPaymentVoucher = 4,
  NewJournal = 5,
  OpenPOS = 6,
  Save = 7,
  Print = 8,
  Search = 9,
  NewCustomer = 10,
  NewVendor = 11,
  NewProduct = 12,
}
